module.exports = __webpack_public_path__ + "static/img/14_sanxiang_4.a7cfcb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/14_sanxiang_4.png
// module id = u/nx
// module chunks = 0